"use strict";

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.triggerTransition = void 0;

var _gatsby = require("gatsby");

var _requestanimationframeTimer = require("requestanimationframe-timer");

var _secondsMs = require("./secondsMs");

var _getPagesPromises = _interopRequireDefault(require("./getPagesPromises"));

var triggerTransition = function triggerTransition(_ref) {
  var to = _ref.to,
      _ref$event = _ref.event,
      event = _ref$event === void 0 ? null : _ref$event,
      _ref$exit = _ref.exit,
      exit = _ref$exit === void 0 ? {} : _ref$exit,
      _ref$entry = _ref.entry,
      entry = _ref$entry === void 0 ? {} : _ref$entry,
      inTransition = _ref.inTransition,
      pages = _ref.pages,
      trigger = _ref.trigger,
      updateContext = _ref.updateContext,
      linkState = _ref.linkState,
      replace = _ref.replace,
      preventScrollJump = _ref.preventScrollJump;

  if (event) {
    event.persist();
    event.preventDefault();
  }

  if (inTransition) return false;
  var hash; // handle anchor links to ID's

  if (to.includes('#')) {
    var toSplit = to.split('#');
    to = toSplit[0];
    hash = toSplit[1];
  } // these globals prevent the back button from being pressed during a transition as that can have unexpected results


  window.__tl_inTransition = true;
  window.__tl_desiredPathname = (0, _gatsby.withPrefix)(to);
  updateContext({
    inTransition: true,
    exitDelay: 0,
    exitLength: 0,
    appearAfter: 0,
    exitState: {}
  });

  if (trigger && typeof trigger === 'function') {
    trigger(pages);
  }

  var _exit$length = exit.length,
      exitLength = _exit$length === void 0 ? 0 : _exit$length,
      _exit$delay = exit.delay,
      exitDelay = _exit$delay === void 0 ? 0 : _exit$delay,
      _exit$state = exit.state,
      exitState = _exit$state === void 0 ? {} : _exit$state,
      _exit$trigger = exit.trigger,
      _exitTrigger = _exit$trigger === void 0 ? function () {} : _exit$trigger;

  var _entry$length = entry.length,
      entryLength = _entry$length === void 0 ? 1 : _entry$length,
      _entry$delay = entry.delay,
      entryDelay = _entry$delay === void 0 ? 0 : _entry$delay,
      _entry$state = entry.state,
      entryState = _entry$state === void 0 ? {} : _entry$state,
      _entry$trigger = entry.trigger,
      _entryTrigger = _entry$trigger === void 0 ? function () {} : _entry$trigger,
      _entry$appearAfter = entry.appearAfter,
      appearAfter = _entry$appearAfter === void 0 ? 0 : _entry$appearAfter;

  updateContext({
    entryLength: entryLength,
    entryDelay: entryDelay,
    exitLength: exitLength,
    exitDelay: exitDelay,
    entryProps: entry,
    exitProps: exit,
    appearAfter: appearAfter,
    preventScrollJump: preventScrollJump,
    exitTrigger: function exitTrigger(exit, node, e) {
      return _exitTrigger(exit, node, e);
    },
    entryTrigger: function entryTrigger(entry, node, e) {
      return _entryTrigger(entry, node, e);
    },
    e: event
  }); // after exitDelay

  (0, _requestanimationframeTimer.setTimeout)(function () {
    (0, _gatsby.navigate)(to, {
      state: _objectSpread({}, linkState),
      replace: replace
    });
    updateContext({
      exitState: exitState,
      hash: hash
    });
  }, (0, _secondsMs.getMs)(exitDelay));
  (0, _requestanimationframeTimer.setTimeout)(function () {
    // wait for entryDelay before we add entry state
    updateContext({
      entryState: entryState
    });
  }, (0, _secondsMs.getMs)(exitDelay + entryDelay)); // reset entry animation times so they dont apply when using browser back/forward.
  //  this will be replaced with a better solution in the future

  (0, _requestanimationframeTimer.setTimeout)(function () {
    return updateContext({
      entryDelay: 0,
      appearAfter: 0,
      entryLength: 0
    });
  }, (0, _secondsMs.getMs)(exitDelay + entryDelay + entryLength));
  var finalResetSeconds = exitDelay + Math.max(exitLength, entryDelay + entryLength); // reset exit animation times so they dont apply when using browser back/forward.
  //  this will be replaced with a better solution in the future

  (0, _requestanimationframeTimer.setTimeout)(function () {
    // these globals prevent the back button from being pressed during a transition as that can have unexpected results
    window.__tl_inTransition = false;
    window.__tl_desiredPathname = false;
    window.__tl_back_button_pressed = false;
    updateContext(_objectSpread({
      exitDelay: 0,
      exitLength: 0,
      // Once all animation is finished, it's safe to start a new animation since we're no longer inTransition.
      inTransition: false
    }, (0, _getPagesPromises.default)()));
  }, (0, _secondsMs.getMs)(finalResetSeconds) + 1);
};

exports.triggerTransition = triggerTransition;